import { FC, ReactNode } from 'react';
import { Paper, Stack, styled } from '@mui/material';

type Size = 'small' | 'large';

const BodyWrapper = styled(Paper)<{ $size: Size; $noPadding?: boolean }>`
  padding: ${({ theme, $noPadding }) => theme.spacing($noPadding ? 0 : 4)};
  width: ${({ $size }) => ($size === 'small' ? 480 : 700)}px;
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  overflow: hidden;

  @media (prefers-reduced-motion: no-preference) {
    animation: slide-in-animation 200ms forwards ease-out;
  }

  @keyframes slide-in-animation {
    0% {
      transform: translateY(20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

type Props = {
  body: ReactNode;
  footer?: ReactNode;
  size?: Size;
  noPadding?: boolean;
};

const CenteredCardView: FC<Props> = ({
  body,
  footer,
  size = 'small',
  noPadding = false,
}) => (
  <Stack alignItems="center" justifyContent="center" height="100%" gap={4}>
    <BodyWrapper elevation={0} $size={size} $noPadding={noPadding}>
      {body}
    </BodyWrapper>
    {footer && <div>{footer}</div>}
  </Stack>
);

export default CenteredCardView;
